import { Text } from 'ui';
import type { EventActionsView } from '../../../types';
import { EventButtonsListLayout } from '../event-buttons-list-layout';
import { EventRsvpButton } from './event-rsvp-button';
import { EventRsvpButtonsDetailLayout } from './event-rsvp-buttons-detail-layout';

export type EventRsvpButtonsProperties = {
  actionGoing: () => void;
  actionNotGoing: () => void;
  hasLabel?: boolean;
  isAccepting: boolean;
  isRejecting: boolean;
};

type P = {
  rsvpButtons: EventRsvpButtonsProperties;
  view: EventActionsView;
};

const EventRsvpButtons = ({ rsvpButtons, view }: P) => {
  const { actionGoing, actionNotGoing, hasLabel, isAccepting, isRejecting } = rsvpButtons;

  const topLabel = 'Respond to invitation';

  switch (view) {
    case 'detail':
      return (
        <EventRsvpButtonsDetailLayout
          left={<EventRsvpButton block loading={isAccepting} onAction={actionGoing} size="large" variant="going" />}
          right={
            <EventRsvpButton block loading={isRejecting} onAction={actionNotGoing} size="large" variant="not_going" />
          }
          top={<Text>{topLabel}</Text>}
        />
      );
    case 'header':
      return null;
    case 'list':
      return (
        <EventButtonsListLayout
          gutter={['xs', 'xxs']}
          left={<EventRsvpButton loading={isAccepting} onAction={actionGoing} size="small" variant="going" />}
          right={<EventRsvpButton loading={isRejecting} onAction={actionNotGoing} size="small" variant="not_going" />}
          top={hasLabel ? <Text size="small">{topLabel}</Text> : null}
        />
      );
  }
};

export default EventRsvpButtons;
